module.exports = __webpack_public_path__ + "img/default-avatar.bd143986.svg";